export const ADMINROUTES = [
  { url: 'customer-support/home', txt: 'Dashboard' },
  { url: 'customer-support/orders', txt: 'Orders' },
  { url: 'customer-support/customers', txt: 'Customers' }
]
